
<template>
  <div>
   <v-row justify="center">
             <v-dialog
               v-model="dialog"
               persistent
               max-width="490"
             >
               <v-card>
                 <v-card-title class="text-h5" style="background-color:#006699;color:white;">
                   MAPA DE CONTROLO TRIMESTRAL
                 </v-card-title>
                 <v-card-text><br>
                       <v-row>
                         <v-col md="12">
                           <v-select
                           v-model="trimestre"
                           item-value="id"
                           item-text="descricao"
                           :items="trimestres"
                           filled
                           color="blue-grey lighten-2"
                           label="Trimestre"
                           outlined
                           return-object
                         ></v-select>
                         </v-col>
                         <v-col md="12">
                           <v-select
                           v-model="disciplina"
                           item-value="iddisciplina"
                           item-text="disciplina"
                           :items="disciplinas"
                           filled
                           color="blue-grey lighten-2"
                           label="Disciplina"
                           outlined
                           return-object
                         ></v-select>
                         </v-col>
                       </v-row>
                 </v-card-text>
                 <v-card-actions>
                   <v-spacer></v-spacer>
                   <v-btn
                     color="darken-1"
                     text
                     @click="fecharComponente()"
                   >
                     Fechar
                   </v-btn>
                   <v-btn
                     color="green darken-1"
                     text
                     :disabled="!trimestre || trimestre.id === 0 || !disciplina || disciplina.iddisciplina === 0"
                     @click="getMeses()"
                    >
                     Continuar
                   </v-btn>
                 </v-card-actions>
               </v-card>
             </v-dialog>
           </v-row>
 </div>
     </template>
<script>
import axios from '../../../plugins/axios'
import utilitariosImpressao from '../../../utilitarios/impressao.utilitario'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
name: 'mapacontrolotrimestral',
props: [],

data: () => ({
  html: '',
  dialog: true,
  trimestre: { id: 0, descricao: '' },
  trimestres: [{
    id: 1,
    descricao: '1º TRIMESTRE'
  },
  {
    id: 2,
    descricao: '2º TRIMESTRE'
  },
  {
    id: 3,
    descricao: '3º TRIMESTRE'
  }
  ],
  meses: [],
  disciplinas: [],
  disciplina: {
    iddisciplina: 0,
    pkturma: 0,
    disciplina: ''
  },
  relatorio: [],
  logotipo: ls.get('logotipo'),
  configuracoesReport: [],
  alunos: [],
  isLoading: false,
  readfile: '',
  mes2: '',
  mes3: '',
  mes1: ''
}),

computed: {
  Instituicao () {
    return ls.get('i_id')
  },
  role () {
    return ls.get('role')
  }
},

created () {
  this.carregarRelatorio()
   this.getDisciplinasByTurma()
},

methods: {
  async getMeses () {
    try {
      this.meses = await axios.get('/getMesesTrimestre/' + this.trimestre.id).then(res => res.data)
      this.dialog = false
      this.getEstudantesByTurma()
    } catch (error) {
      this.fecharComponente()
      Swal.fire('Informação', 'Ocorreu um erro ao tentar efectuar a operação', 'error')
    } finally {
      this.$store.state.isloading = false
    }
  },
  async getDisciplinasByTurma () {
    try {
      this.disciplinas = await axios
        .post('/disciplina_curso_classe', { idCurso: this.$store.state.disciplinaTurma.idCurso, idanoacademico: this.$store.state.disciplinaTurma.idAno_Academico, turma: this.$store.state.disciplinaTurma.pkTurma })
        .then(res => res.data)
      
    } catch (error) {
      this.fecharComponente()
    } finally {
      this.$store.state.isloading = false
    }
  },
  async getEstudantesByTurma () {
    try {
      let value = {
        idDsciplina: this.disciplina.iddisciplina,
        pkTurma: this.$store.state.disciplinaTurma.pkTurma,
        anoLectivo: this.$store.state.disciplinaTurma.anoLectivo
      }
      this.alunos = await axios
        .post('/miniPauta', value)
        .then(res => res.data)
      if (this.alunos.length) this.alunos = this.alunos[0]
      this.comporHTML()
    } catch (error) {
      Swal.fire('Informação', 'Ocorreu um erro ao tentar efectuar a operação', 'error')
    }
  },
  // async criarRelatorio () {
  //   try {
  //     this.$store.state.isloading = true
  //     let result = await axios({
  //       method: 'post',
  //       url: 'http://localhost:8085/createReport',
  //       // url: ls.get('urlReport') + 'createReport',
  //       data: {
  //         instituicao: ls.get('instituicaodescricao').toUpperCase(),
  //         instituicaofilial: 'INSTITUTO TÉCNICO PRIVADO DE SAÚDE',
  //         anolectivo: ': ' + this.$store.state.novadescricaoSelecionado,
  //         alunos: this.alunos,
  //         logotipo: 'logotipoinstituicao',
  //         namefile: 'mapacontrolotrimestral',
  //         urllogotipo: ls.get('logotipo'),
  //         templatename: 'mapacontrolotrimestral.docx',
  //         mes1: this.meses[0],
  //         mes2: this.meses[1],
  //         mes3: this.meses[2],
  //         disciplina: this.disciplina.disciplina.toLocaleUpperCase(),
  //         datacorrente: this.correntDate(),
  //         classe: this.$store.state.disciplinaTurma.classe_descricao,
  //         turma: ': ' + this.$store.state.disciplinaTurma.turmadescricao,
  //         trimestre: this.trimestre.descricao
  //       }
  //     }).then(res => res.data)
  //     if (result && result.value.length) {
  //       console.log(result.value)
  //       this.docxtoPDF(result.value)
  //     }
  //   } catch (error) {
  //     this.fecharComponente()
  //     Swal.fire({
  //       icon: 'error',
  //       title: '',
  //       text: 'Ocorreu um erro ao criar o documento'
  //     })
  //   }
  // },
  async carregarRelatorio () {
      try {        
        this.relatorio = await axios
          .get('/obterRelatorioByDescricao/mct')
          .then(res => res.data) 
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao carregar o relatório'
        })
      }
    },
  async comporHTML () {
    try {
      this.html = this.relatorio[0].documento
      let documentoiter = this.relatorio[0].documentoiteracao1
      const option = { 'format': 'A4',
        'orientation': 'portrait',
        'border': { 'right': '7mm', 'left': '7mm' },
        'header': { 'height': '7mm' },
        'footer': { 'height': '7mm' } }
        this.html = this.html.replace(/{{instituicaodescricao}}/g, ls.get('instituicaodescricao').toUpperCase())
        this.html = this.html.replace(/{{disciplina}}/g, this.disciplina.disciplina.toLocaleUpperCase())
        this.html = this.html.replace(/{{trimestre}}/g, this.trimestre.descricao)
        this.html = this.html.replace(/{{classe}}/g, this.$store.state.disciplinaTurma.classe_descricao)

        
        this.html = this.html.replace(/{{mes1}}/g, (this.meses.length >= 1 ? this.meses[0].descricao : ''))
        this.html = this.html.replace(/{{mes2}}/g, (this.meses.length >= 2 ? this.meses[1].descricao : ''))
        this.html = this.html.replace(/{{mes3}}/g, (this.meses.length >= 3 ? this.meses[2].descricao : ''))
        this.html = this.html.replace(/{{mes4}}/g, (this.meses.length >= 4 ? this.meses[3].descricao : ''))

        this.html = this.html.replace(/{{turma}}/g, this.$store.state.disciplinaTurma.turmadescricao)
        this.html = this.html.replace(/{{anolectivo}}/g, this.$store.state.novadescricaoSelecionado)
        this.html = this.html.replace(/{{dataactual}}/g, this.correntDate())
        this.html = this.html.replace(/{{assinatura1}}/g, '')
        this.html = this.html.replace(/{{assinatura2}}/g, '')
        let dados = ``
        this.alunos.forEach(element => {
          let iteracao = documentoiter
          iteracao = iteracao.replace(/{{nomeAluno}}/g, element.nome.toUpperCase())
          iteracao = iteracao.replace(/{{mac1}}/g, '')
          iteracao = iteracao.replace(/{{nf1}}/g, '')
          iteracao = iteracao.replace(/{{mac2}}/g, '')
          iteracao = iteracao.replace(/{{nf2}}/g, '')
          iteracao = iteracao.replace(/{{mac3}}/g, '')
          iteracao = iteracao.replace(/{{nf3}}/g, '')
          iteracao = iteracao.replace(/{{mmac}}/g, '')
          iteracao = iteracao.replace(/{{teste1}}/g, '')
          iteracao = iteracao.replace(/{{teste2}}/g, '')          
          iteracao = iteracao.replace(/{{mtt}}/g, '')
          iteracao = iteracao.replace(/{{ntf}}/g, '')
          iteracao = iteracao.replace(/{{mft}}/g, '')
          iteracao = iteracao.replace(/{{obs}}/g, '')
          dados += iteracao
      })
      this.html = this.html.replace(/{{css}}/g, this.relatorio[0].css)
      this.html = this.html.replace(/{{dados}}/g, dados)
      utilitariosImpressao.htmlToPDF(this.html, option, ls.get('urlReport'), this.nameFile)
    } catch (error) {
      this.fecharComponente()
    } finally {
      this.fecharComponente()
    }
  },
  correntDate () {
    let data = new Date()
    var month = []
    month[0] = 'Janeiro'
    month[1] = 'Fevereiro'
    month[2] = 'Março'
    month[3] = 'Abril'
    month[4] = 'Maio'
    month[5] = 'Junho'
    month[6] = 'Julho'
    month[7] = 'Agosto'
    month[8] = 'Setembro'
    month[9] = 'Outubro'
    month[10] = 'Novembro'
    month[11] = 'Dezembro'
    return data.getDate().toString() + ' de ' + month[(data.getMonth())] + ' de ' + data.getFullYear().toString() + ' ás ' + data.getHours() + ':' + data.getMinutes() + ':' + data.getSeconds()
  },
  fecharComponente () {
    this.dialog = false
    this.$store.state.isloading = false
    this.$store.state.showDialogGuia.mapacontroltrimestral.componente = false
    this.$emit('fecharComponente', false)
  }
}
}
</script>
<style></style>